// ============================================================================
//  DADOS DA PÁGINA DE SERVIÇOS
// ============================================================================
//
//  Origem de cada campo:
//
//  • `description` — texto que já estava no site (secção "OS NOSSOS SERVIÇOS"
//    da Home), exceto nos serviços de telecomunicações, segurança e água,
//    cujo conteúdo foi indicado pela Cubic.
//
//  • `scope` — CONFIRMADO pela Cubic em:
//        · Telecomunicações — Rede Fixa
//        · Telecomunicações Móveis
//        · Data Centers
//        · Captação, Transporte, Distribuição e Tratamento de Água
//
//    ⚠️  Nos restantes seis serviços é uma PROPOSTA, escrita a partir do que
//    é habitual em cada área, e ainda NÃO foi validada. Rever e corrigir
//    antes de publicar. Os pontos por decidir estão assinalados com ⚠️.
// ============================================================================

import LinhasImage from "../assets/services/projetosAltaTensao";
import CentraisImage from "../assets/services/projetosCentrais";
import SubestacaoImage from "../assets/services/subestacao.png";
// Fotografia do Pexels (licença Pexels: uso comercial livre, sem atribuição
// obrigatória) — https://www.pexels.com/photo/4486718/
import TeleFixaImage from "../assets/services/bastidor-fibra.jpg";
import TeleMovelImage from "../assets/projects/Site-Transmissao-4G-Luanda-2.jpeg";
// ⚠️ Imagem provisória: não há no projeto nenhuma fotografia de
//    videovigilância ou controlo de acessos. Esta é de um edifício do vosso
//    portfólio. Substituir por uma imagem própria da área de segurança.
import SegurancaImage from "../assets/projects/ANMP_1.jpeg";
import BaixaTensaoImage from "../assets/services/projetosBaixaTensao";
import AguaImage from "../assets/projects/agua.jpeg";
// Fotografia do Pexels (licença Pexels: uso comercial livre, sem atribuição
// obrigatória) — https://www.pexels.com/photo/server-racks-on-data-center-4508751/
import DataCenterImage from "../assets/services/data-center.jpg";
import OutrasImage from "../assets/services/projetosOutras";

export const services = [
  {
    id: "linhas-media-alta-tensao",
    title: "Linhas de Média e Alta Tensão",
    image: LinhasImage,
    imageAlt: "Linha aérea de média tensão em meio rural",
    description:
      "Entendemos a complexidade e a responsabilidade inerentes às redes de distribuição.",
    scope: [
      "Traçado e estudo de corredores",
      "Cálculo mecânico de condutores e apoios",
      "Dimensionamento de isolamento e proteção contra descargas atmosféricas",
      "Sistemas de terra",
      "Licenciamento e articulação com o operador de rede",
      "Projeto de execução e assistência técnica à obra"
    ]
  },
  {
    id: "centrais-solares-bess",
    title: "Centrais Solares e BESS",
    image: CentraisImage,
    imageAlt: "Painéis fotovoltaicos de uma central solar",
    description:
      "Desenvolvemos projetos de centrais solares (utility-scale, UPP, UPAC e CER) de alta eficiência que ajudam os nossos clientes a adotar fontes de energia renovável e economizar custos a longo prazo.",
    scope: [
      "Estudo de produção e layout do parque",
      "Dimensionamento DC/AC, inversores e transformação",
      "Armazenamento (BESS): dimensionamento e integração",
      "Posto de seccionamento e ligação à rede",
      "Licenciamento (UPP, UPAC, CER) e registo",
      "Projeto de execução, cadernos de encargos e medições"
    ]
  },
  {
    id: "subestacoes",
    title: "Subestações",
    image: SubestacaoImage,
    imageAlt: "Aparelhagem de alta tensão numa subestação",
    description:
      "Concebemos soluções de engenharia para subestações de energia elétrica que combinam rigor técnico, inovação e conformidade regulamentar, assegurando elevados padrões de fiabilidade e desempenho. Desenvolvemos projetos à medida, orientados para a integração eficiente e sustentável em redes de transporte e distribuição de média, alta e muito alta tensão.",
    scope: [
      "Arranjo geral e dimensionamento de aparelhagem (AIS / GIS)",
      "Serviços auxiliares CA/CC",
      "Sistemas de proteção, comando e controlo",
      "Rede de terras e proteção contra descargas atmosféricas",
      "Obra civil associada e edifício de comando",
      "Coordenação de isolamento"
    ]
  },
  {
    id: "telecomunicacoes-rede-fixa",
    title: "Telecomunicações — Rede Fixa",
    image: TeleFixaImage,
    imageAlt: "Bastidor de fibra ótica com conectores e patch cords",
    description:
      "Cadastro e projetos de execução para redes de fibra ótica FTTH e FTTx.",
    scope: [
      "Cadastro de rede",
      "Projetos de execução FTTH e FTTx",
      "ITED e ITUR",
      "Cablagem estruturada e redes de dados"
    ]
  },
  {
    id: "telecomunicacoes-moveis",
    title: "Telecomunicações Móveis",
    image: TeleMovelImage,
    imageAlt: "Torres de telecomunicações com antenas",
    description:
      "Projetos para estações base, do levantamento inicial do local à documentação final da obra.",
    // Âmbito confirmado pela Cubic.
    scope: [
      "Identificação de candidatos",
      "Negociação e contratação de locais",
      "Licenciamento",
      "Projetos de engenharia e implementação de sites",
      "Construção civil",
      "Reengenharias e partilhas de sites",
      "Inspeções e auditorias",
      "Aceitações",
      "Relatórios de site survey e documentação as-built"
    ]
  },
  {
    id: "seguranca",
    title: "Projetos de Segurança",
    image: SegurancaImage,
    imageAlt: "Edifício com sistemas de segurança integrados",
    description:
      "Integramos projetos de segurança que reforçam a proteção e o desempenho dos edifícios, articulados com as restantes especialidades técnicas.",
    scope: [
      "Videovigilância (CCTV)",
      "Controlo de acessos",
      "Deteção de intrusão"
      // ⚠️ Acrescentar aqui o que mais fizerem nesta área — por exemplo
      //    deteção de incêndio, se for serviço vosso.
    ]
  },
  {
    id: "data-centers",
    title: "Data Centers",
    image: DataCenterImage,
    imageAlt: "Corredor de um data center com filas de bastidores",
    description:
      "Projetos de licenciamento e de execução para data centers.",
    // Âmbito confirmado pela Cubic.
    // ⚠️ Se quiserem detalhar (energia, redundância, climatização,
    //    deteção e extinção, monitorização), acrescentar aqui.
    scope: ["Projetos de licenciamento", "Projetos de execução"]
  },
  {
    id: "instalacoes-media-baixa-tensao",
    title: "Instalações Elétricas de Média e Baixa Tensão",
    image: BaixaTensaoImage,
    imageAlt: "Quadro elétrico de distribuição",
    description:
      "Oferecemos soluções personalizadas para instalações de média e baixa tensão, desde a distribuição de energia e iluminação até à alimentação de equipamentos e integração com os restantes sistemas técnicos do edifício.",
    scope: [
      "Postos de transformação",
      "Quadros elétricos e distribuição",
      "Iluminação interior, exterior e de emergência",
      "Alimentação de equipamentos e sistemas técnicos",
      "Compensação de energia reativa",
      "Rede de terras e proteção contra sobretensões"
    ]
  },
  {
    id: "agua",
    title: "Captação, Transporte, Distribuição e Tratamento de Água",
    image: AguaImage,
    imageAlt: "Estação de tratamento de água com grupos de bombagem",
    description:
      "Desenvolvemos projetos no ciclo urbano da água, da captação ao tratamento e reutilização, incluindo drenagem pluvial e os estudos hidrológicos que os suportam.",
    // Âmbito confirmado pela Cubic.
    scope: [
      "Projetos de captação",
      "Projetos de transporte e distribuição de água",
      "Projetos de tratamento de água",
      "Projetos de tratamento de águas residuais",
      "Projetos de dessalinização",
      "Projetos de reutilização de água",
      "Projetos de drenagem de águas pluviais",
      "Estudos hidrológicos"
    ]
  },
  {
    id: "outras-especialidades",
    title: "Outras Especialidades",
    image: OutrasImage,
    imageAlt: "Vista noturna de um empreendimento urbano",
    description:
      "Com base nos consórcios que desenvolvemos, damos resposta a todas as áreas de engenharia, minimizando preocupações com contratações de serviços por parte dos nossos clientes. Somos versáteis e capazes de abordar projetos desafiantes em diversas disciplinas da engenharia.",
    // ⚠️ Lista por confirmar — indicar as especialidades reais cobertas por
    //    consórcio. Tal como está, é vaga de mais.
    scope: [
      "Estabilidade e estruturas",
      "AVAC",
      "Segurança contra incêndio"
    ]
  }
];

export default services;
